export default __webpack_public_path__ + "static/figure4-b49df4bd1d699885fe7f7f073699b675.webp";